<template>
    <div>
        <div class="question-container">
            <div class="question-number-container">
                <RouterLink to="/"><img :src="eclore" class="leaveImg"/></RouterLink>
            </div>
            <div class="question-text-container">
                <h1 class="question-text">
                    Vos résultats
                </h1>
                <p class="paragraph z-1000">Éclore fonds environnement Trois-Rivières vous remercie d’avoir
                    calculé l’empreinte carbone de <span v-if="who==='Un touriste'">
                        votre voyage.
                    </span>
                    <span v-if="who==='Un évènement'">
                        votre évènement.
                    </span>
                    <span v-if="who==='Une organisation'">
                        votre organisation.
                    </span>
                    <span v-if="who==='Un citoyen'">
                        votre ménage.
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            eclore: require('@/assets/images/eclore_big_logo.png'),
        };
    },
    props: {
        number: String,
        question: String,
        comment: String,
        modalActivator:{type:Boolean, default:false},
        modalActive:{type:Boolean, default:false},
        who:{type:String, default:'Touriste'},
    },
};
</script>
<style scoped>
.question-container {
    position: relative;
    width: 92%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    height:100%;
}
.question-number-container {
    position: relative;
}
.question-number {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 25rem;
    font-style: normal;
    font-weight: 900;
    line-height: 1em;
    opacity: 0.25;
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
}
.question-text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left:-3%;
}
.question-text {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 4.2rem;
    line-height: 1.1em;
    font-style: normal;
    font-weight: 600;
    z-index: 1000;
    margin-bottom: 0px;
}
.z-1000{
    z-index:1000;
}
.comment-text {
    margin-top: 0;
    color: var(--text-color);
    font-family: var(--font);
    font-size: 2rem;
    font-style: normal;
    font-weight: 600;
    line-height: 44.2px;
    z-index: 1000;
}
.info-img{
    cursor:pointer;
}
.leaveImg {
  max-width: 240px;
}
  @media screen and (max-width: 1400px) {
  .leaveImg {
    max-width: 160px;
  }

  .question-text {
    font-size: 2.5rem;
    line-height: 1.1em;
  }

  .text-container-header {
    left: 55px;
  }

  .question-number {
    font-size: 10rem;
  }


}

@media screen and (max-width: 900px) {
  .question-text {
    font-size: 2.5rem;
    line-height: 1.1em;
  }

  .leaveImg {
    max-width: 120px;
  }

}
@media screen and (max-width: 600px) {
  .leaveImg{
    max-width:110px;
  }
  .question-text{
    font-size: 2rem;
    line-height: 1.1em;
  }
  .text-container-header{
    left:55px;
  }
  .question-number {
    font-size: 10rem;
  }
  .info-img>img{
    width:80px;
  }
}

</style>